// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__OiLyH","name":"Header_name__3knNj","birthday":"Header_birthday__Zq7Ne","skeleton":"Header_skeleton__pCeyp"};